import React, { useState } from "react";
import styles from "./ExpandedModeBadge.module.css";

type ExpandedModeBadgeProps = {
  className?: string;
};

/**
 * Displays badge indicating response was generated in Expanded Mode.
 * Shows tooltip explaining what expanded mode means.
 */
export const ExpandedModeBadge: React.FC<ExpandedModeBadgeProps> = ({ className }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={`${styles.badgeContainer} ${className || ""}`}>
      <span
        className={styles.badge}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        tabIndex={0}
        role="note"
        aria-describedby="expanded-mode-tooltip"
      >
        <span className={styles.icon}>+</span>
        Expanded
      </span>

      {showTooltip && (
        <div id="expanded-mode-tooltip" className={styles.tooltip} role="tooltip">
          <div className={styles.tooltipContent}>
            <strong>Expanded Mode</strong>
            <p>
              This response was generated using Expanded Mode, which provides
              more detailed technical information and comprehensive regulatory
              analysis.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
